import { ECountry, EPayBrand, EPaymentMethod } from 'common/const';
import { getOrganizationCountry } from 'common/helpers/country.helper';

type TDeviceInfo = Pick<Navigator, 'userAgent' | 'platform'>;

const APPLE_DEVICE = /iPhone|iPad|iPod|Macintosh|Mac OS X/i;
const APPLE_PLATFORM = /^(Mac|iPhone|iPad|iPod)/i;

/* Бренд кнопки Apple Pay / Google Pay по устройству (payment-buttons, R-1, O-2): устройства Apple
 *  (iPhone, iPad, Mac; iPadOS отдаёт UA Macintosh) - Apple Pay, остальные - Google Pay. Точность не
 *  гарантируется: форма банка всё равно показывает способ по реальному устройству (walkthrough, шаг 5). */
export const getPayBrand = (device: TDeviceInfo | undefined = globalThis.navigator): EPayBrand =>
  device && (APPLE_PLATFORM.test(device.platform ?? '') || APPLE_DEVICE.test(device.userAgent ?? ''))
    ? EPayBrand.ApplePay
    : EPayBrand.GooglePay;

/* Кнопка Apple Pay / Google Pay - только сербская организация (R-6, O-5). Организации ещё нет - кнопки нет;
 *  ответ старого API без страны - RS, как везде на странице (country.helper). */
export const isPayBrandEnabled = (organization?: { country?: ECountry } | null): boolean =>
  !!organization && getOrganizationCountry(organization) === ECountry.RS;

const PAY_BRAND_METHODS: Record<EPayBrand, EPaymentMethod> = {
  [EPayBrand.ApplePay]: EPaymentMethod.ApplePay,
  [EPayBrand.GooglePay]: EPaymentMethod.GooglePay,
};

/* Способ оплаты, который сообщает бэку кнопка бренда (payment-method-rename, R-7): маршрут выбирает бэк. */
export const getPayBrandMethod = (brand: EPayBrand): EPaymentMethod => PAY_BRAND_METHODS[brand];
